import React, { useState } from 'react';
import classNames from "classnames";
import { Modal, Segment, Table } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import GoBackTitle from "@/pages/datalab/components/GoBackTitle";
import { IDetailModalBodyProps, IDetailModalProps, ISegmentOption } from './types';

const { scrollable, autotip } = Table.addons;

/**
 * 将弹窗展示内容 拆分到单独的组件, 对 segment等状态进行单独管理
 * 这样在每次弹窗关闭后, 可以销毁状态, 重新打开弹窗时, 状态为默认态
 */
const DetailModalBody: React.FC<IDetailModalBodyProps> = (props) => {
  const { struct, preview } = props;
  const { formatMessage } = useIntl();
  const [segment, setSegment] = useState<string>('structure');
  const options: ISegmentOption[] = [
    { text: formatMessage({ id: 'dbl_personal_data_table_structure' }), value: 'structure' },
    { text: formatMessage({ id: 'dbl_personal_data_data_preview' }), value: 'preview' },
  ];
  const { loading, error, columns, records } = segment === 'structure' ? struct : preview;
  const autotipStyle = loading ? {} : { lineHeight: '200px' };
  
  return (<Modal.Body>
    <Segment
      className="dbl-datasource-detail-segments"
      value={segment}
      onChange={(value) => setSegment(value)}
      options={options}
    />
    <Table
      key={segment}
      className={classNames('dbl-datasource-detail-table', {
        'dbl-datasource-detail-table--loading': loading,
      })}
      columns={columns}
      records={loading ? [] : records}
      addons={[
        scrollable({
          maxHeight: 'calc(100% - 74px)',
          minWidth: 1000,
          scrollToTopOnChange: true,
        }),
        autotip({
          isLoading: loading,
          isError: !!error,
          style: autotipStyle,
          emptyText: formatMessage({ id: 'dbl_common_not_search' }),
          loadingText: formatMessage({ id: 'dbl_common_loading' }),
          errorText: formatMessage({ id: 'dbl_common_load_fail' }),
        }),
      ]}
    />
  </Modal.Body>);
};

const DetailModal: React.FC<IDetailModalProps> = (props) => {
  const { title, goBack, struct, preview, visible, onClose, className, ...restProps } = props;
  return (
    <Modal
      size="80%"
      {...restProps}
      visible={visible}
      // caption={<span style={{ fontSize: 16, fontWeight: 'bold' }}>{title}</span>}
      caption={<GoBackTitle title={title || ''} isShowGoBack={!!goBack} onGoBack={goBack} />}
      onClose={onClose}
      className={classNames('dbl-datasource-detail', className)}
    >
      <DetailModalBody
        struct={struct}
        preview={preview}
      />
    </Modal>
  );
};

export default DetailModal;
